export default __webpack_public_path__ + "static/media/brex_logo.75b2276e.png";